import { Loader2, Check, AlertCircle, X } from 'lucide-react';
import { useAssetStore } from '../../../stores/assetStore';
import { formatBytes, percentSaved } from '../../../lib/assetCompression';

export default function AssetUploadQueue() {
  const { uploadQueue, clearCompletedUploads } = useAssetStore();

  if (uploadQueue.length === 0) return null;

  const anyDone = uploadQueue.some((u) => u.status === 'complete' || u.status === 'error');

  return (
    <div className="border-t border-white/[0.06] bg-[#0a0a0a] max-h-40 overflow-y-auto sidebar-scroll">
      <div className="flex items-center justify-between px-3 py-1.5 sticky top-0 bg-[#0a0a0a] z-10 border-b border-white/[0.04]">
        <span className="text-[10px] text-zinc-500 uppercase tracking-wider">
          Uploads ({uploadQueue.length})
        </span>
        {anyDone && (
          <button
            onClick={clearCompletedUploads}
            className="text-[10px] text-zinc-500 hover:text-zinc-300"
          >
            Clear done
          </button>
        )}
      </div>
      <div className="p-2 space-y-1.5">
        {uploadQueue.map((u) => {
          const saved = percentSaved(u.originalSize, u.compressedSize);
          return (
            <div
              key={u.id}
              className="flex items-center gap-2 px-2 py-1.5 rounded bg-white/[0.02] border border-white/[0.04]"
            >
              <div className="shrink-0">
                {u.status === 'complete' ? (
                  <Check size={12} className="text-emerald-400" />
                ) : u.status === 'error' ? (
                  <AlertCircle size={12} className="text-red-400" />
                ) : (
                  <Loader2 size={12} className="animate-spin text-cyan-400" />
                )}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-[11px] text-zinc-300 truncate">{u.fileName}</p>
                <p className="text-[9px] text-zinc-600">
                  {u.status === 'complete' && u.compressedSize > 0
                    ? `${formatBytes(u.originalSize)} - ${formatBytes(u.compressedSize)}${
                        saved > 0 ? ` (saved ${saved}%)` : ''
                      }`
                    : u.status === 'error'
                    ? u.message || 'Failed'
                    : u.status === 'compressing'
                    ? 'Compressing...'
                    : u.status === 'uploading'
                    ? 'Uploading...'
                    : 'Saving...'}
                </p>
              </div>
              {(u.status === 'complete' || u.status === 'error') && (
                <button
                  onClick={clearCompletedUploads}
                  className="text-zinc-600 hover:text-zinc-300 shrink-0"
                >
                  <X size={10} />
                </button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
